module.exports = __webpack_public_path__ + "../resources/img/@temp_house.ae7f2e37.jpg";